import { useMediaQuery, useTheme } from "@mui/material";
import { useElements, useStripe } from "@stripe/react-stripe-js";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { useLogging } from "../../../Shared/hooks/useLogging/useLogging";
import { usePaymentMethodCreate } from "../Shared/hooks/PaymentMethodCreate/usePaymentMethodCreate";
import { usePaymentMethodUpdate } from "../Shared/hooks/PaymentMethodUpdate/usePaymentMethodUpdate";
import { StatusType } from "../Shared/types/PaymentProcessorTypes";
import { handleClose, onSubmit, resetFields } from "./StripeCardForm-utils";
const initStripeCardFormState = {
    loading: false,
    status: {
        message: undefined,
        type: StatusType.IDLE,
    },
    submitted: false,
};
/**
 * useStripeCardForm(selectedCard) - Handles loading of stripe elements.
 *
 * @param selectedCard
 * @returns
 */
export const useStripeCardForm = (selectedCard) => {
    const theme = useTheme();
    const stripe = useStripe();
    const elements = useElements();
    const [cardFormState, setCardFormState] = useState(initStripeCardFormState);
    const { createPaymentMethod } = usePaymentMethodCreate();
    const { updatePaymentMethod } = usePaymentMethodUpdate();
    const { datadogLog } = useLogging();
    const mobile = useMediaQuery(theme.breakpoints.down("sm"), { noSsr: true });
    const { handleSubmit, control, resetField, clearErrors, formState: { errors }, } = useForm({
        mode: "onChange",
    });
    const defaultValues = {
        cardHolderName: selectedCard ? selectedCard.card.name : "",
        isPrimaryChecked: selectedCard ? selectedCard.isPrimary : false,
    };
    return {
        handleSubmit,
        handleClose: handleClose(resetFields(resetField), clearErrors, cardFormState, setCardFormState),
        control,
        defaultValues,
        errors,
        loading: cardFormState.loading,
        onSubmit: onSubmit(stripe, elements, setCardFormState, createPaymentMethod, updatePaymentMethod, datadogLog, selectedCard),
        stripe,
        cardFormState,
        mobile,
    };
};
